

import { defineComponent } from 'vue'
import NavBar from '@/components/NavBar.vue'
import Students from '@/components/Students.vue'

export default defineComponent({
  name: 'App',
  components: { Students, NavBar },
  setup() {
  },
})
